/**
 * TRCE Phase 4 — L9 AI context types (client).
 */
export type TrceAiContextSlice = {
  profile: {
    countryCode: string;
    persona: string;
    locale: string;
    tone: string;
    maxRiskScore: number;
    systemHints: string[];
    source: string;
  };
  allowedFeatures: string[];
  blockedFeatures: string[];
  policies: Array<{ policyCode: string; name: string; riskScore: number }>;
  features: Array<{ featureKey: string; name: string; deploymentStatus: string }>;
  securityGate: { principle: string; prohibitedActionCount: number };
  count: number;
};

export type TrceDashboardWidget = {
  widgetKey: string;
  widgetType: string;
  titleEn: string;
  titleFa: string;
  apiEndpoint: string;
  dataPath: string;
  format: string;
};

export type TrceDashboardSlice = {
  widgets: TrceDashboardWidget[];
  layout: { columns: number; widgetKeys: string[] } | null;
  count: number;
};

export function isAiFeatureAllowed(ctx: TrceAiContextSlice | null, featureKey: string): boolean {
  if (!ctx) return false;
  if (ctx.blockedFeatures.includes(featureKey)) return false;
  if (ctx.allowedFeatures.length === 0) return true;
  return ctx.allowedFeatures.some(a => featureKey === a || featureKey.startsWith(`${a}.`) || featureKey.startsWith(a));
}
